(function authNotificationConfigControllerDefinition() {
    'use strict';

    angular.module('AuthNotificationConfig')
        .controller('AuthNotificationConfigDetailController', [
            '$scope', '$state', '$stateParams', 'errorsExtend', '$filter', 'adminAuthNotificationConfigService','fileDownloader',
            function AuthNotificationConfigDetailController($scope, $state, $stateParams, errors, $filter, adminAuthNotificationConfigService, fileDownloader) {
                $scope.load = function () {

                    adminAuthNotificationConfigService.getById($stateParams.id).then(function (result) {
                        if (!result) {
                            errors.showError('NotificationNotFound');
                            $state.go('auth-notification-config-find');
                        }

                        $scope.notificationConfig = result;

                        var title = $filter('filter')(result.datas, { key: 'title' }, true)[0];
                        $scope.notificationConfig.title = title ? title.value : '';

                        var body = $filter('filter')(result.datas, { key: 'body' }, true)[0];
                        $scope.notificationConfig.body = body ? body.value : '';

                        var needsSignature = $filter('filter')(result.datas, { key: 'needsSignature' }, true)[0];
                        $scope.notificationConfig.needsSignature = needsSignature ? needsSignature.value : '';

                        var sendMail = $filter('filter')(result.datas, { key: 'sendMail' }, true)[0];
                        $scope.notificationConfig.sendMail = sendMail ? sendMail.value : '';

                        var file = $filter('filter')(result.datas, { key: 'fileId' }, true)[0];
                        $scope.notificationConfig.file = file ? 'Archivo' : '';

                    }, function (error) {
                        errors.showError(error);
                    });
                };              

                $scope.cancel = function () {
                    $state.go('auth-notification-config-find');
                };

                $scope.downloadTYC = function () {
                    var d = new Date();
                    var month = d.getUTCMonth() + 1;
                    var success = fileDownloader.saveAs($scope.notificationConfig.files[0].fileBase64, 'Términos y Condiciones - ' +
                        d.getUTCFullYear() +
                        ("00".substring(0, 2 - (month + '').length) + month) +
                        ("00".substring(0, 2 - (d.getDate() + '').length) + d.getDate()) +
                        '.pdf');
                    if (!success) {
                        errors.showError('Api failed');
                    }
                }
                $scope.load();
            }
        ]);
})();